import moment from 'moment';

const parseTime = (time) => {
    if(!time) return `-`
    else {
        return moment(time).format("YYYY/MM/DD HH:mm:ss");
    }
}

export default parseTime;